import { CommonPlayerEventParams } from '../useCommonPlayerEventParams';
import { useTriggerOnPlayerEvent } from '../useTriggerOnPlayerEvent';

export const useTriggerOnPlaybackPause = (params: CommonPlayerEventParams) =>
    useTriggerOnPlayerEvent(params, 'PLAYBACK_PAUSE');
